import React from 'react';
import './styles.css'; // Ensure you import the stylesheet

const RotatingSlash = () => {
  return <span className="unix-spin text-xs font-mono"></span>;
};

export default RotatingSlash;
